function componentCustom() {
  // START
  $(".sidebar-left h4:contains('Kategórie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);

  $(".sidebar-left h4:contains('Kategorie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);

  $(".sidebar-left h4:contains('Typ ihličia')").addClass("sidebar-jehlici");
  $(".sidebar-left h4:contains('Typ jehel')").addClass("sidebar-jehlici");
  $(".sidebar-left h4:contains('Typ stromčeka')").addClass("sidebar-strom");
  $(".sidebar-left h4:contains('Typ stromu')").addClass("sidebar-strom");
  $(".sidebar-left h4:contains('Veľkosť stromčeka')").addClass(
    "sidebar-velikost"
  );
  $(".sidebar-left h4:contains('Velikost stromu')").addClass(
    "sidebar-velikost"
  );
  $(".sidebar-left h4:contains('Farba')").addClass("sidebar-farba");
  $(".sidebar-left h4:contains('barva')").addClass("sidebar-farba");

  $(".mobile .filter-sections h4:contains('Kategórie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);
  $(".mobile .filter-sections h4:contains('Kategorie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);
  $(".mobile .filter-sections h4:contains('Kategorie')")
    .addClass("sidebar-ponuka")
    .text("Nabídka stromků");
  $(".mobile .filter-sections h4:contains('Typ ihličia')").addClass(
    "sidebar-jehlici"
  );
  $(".mobile .filter-sections h4:contains('Typ jehel')").addClass(
    "sidebar-jehlici"
  );
  $(".mobile .filter-sections h4:contains('Typ stromčeka')").addClass(
    "sidebar-strom"
  );
  $(".mobile .filter-sections h4:contains('Typ stromu')").addClass(
    "sidebar-strom"
  );
  $(".mobile .filter-sections h4:contains('Veľkosť stromčeka')").addClass(
    "sidebar-velikost"
  );
  $(".mobile .filter-sections h4:contains('Velikost stromu')").addClass(
    "sidebar-velikost"
  );
  $(".mobile .filter-sections h4:contains('Farba')").addClass("sidebar-farba");
  $(".mobile .filter-sections h4:contains('Barva')").addClass("sidebar-farba");

  $(".type-category .product").each(function () {
    //loop over each list item
    // myPrice = $(".price-standard", this); //get the year of the current list item
    // $(".prices", this).append(myPrice); //append it to the item information
  });

  $(".type-category .product").each(function () {
    //loop over each list item
    mySave = $(".price-save", this); //get the year of the current list item
    $(".flags-default", this).append(mySave); //append it to the item information
  });

  $(".type-category .product").each(function () {
    //loop over each list item
    myDoprava = $(".flag-freeshipping .flag-text", this); //get the year of the current list item
    $(".p-tools", this).append(myDoprava.text(freeDelivery)); //append it to the item information
  });

  $(".desktop.type-category .category-perex").insertAfter(".type-category h1");
  $('.type-category h4:contains("' + mostSelling + '")').remove();

  $(".checkout-box-wrapper h4").html(questionBanner);

  $(".cart-empty h4").html(questionBanner);
  // END

  /*$(".welcome").insertAfter("#header");*/
  $(".welcome").insertAfter(".type-index .products");

  $(".rozcestnik").insertAfter(".banners-row");
  $(".zapati").insertBefore("#footer");

  $(".type-detail .p-detail-inner-header").insertBefore(
    ".p-final-price-wrapper"
  );
  $(".type-detail .p-short-description").insertAfter(".type-detail h1");
  $('.type-detail a:contains("' + detailInfo + '")').remove();
  $(".type-detail .availability-value").insertAfter(".type-detail h1");

  var hText = $(".detail-parameters").find("td").text();

  if (
    hText.indexOf("Borovica") >= 0 ||
    hText.indexOf("Borovice") >= 0 ||
    hText.indexOf("Jedle") >= 0 ||
    hText.indexOf("Jedla") >= 0 ||
    hText.indexOf("Jedľa") >= 0 ||
    hText.indexOf("Smrk") >= 0 ||
    hText.indexOf("Smrek") >= 0
  ) {
    $(".type-detail .products-related-header").text(similiarTree);
  } else {
    $(".type-detail .products-related-header").text("Podobné ozdoby");
  }

  // $(".mobile.type-detail .p-detail-inner-header").insertBefore(
  //   ".p-image-wrapper"
  // );

  $(".type-detail .detail-bannery").insertAfter(".add-to-cart");

  $(".type-detail #description").insertAfter(".p-detail-inner");

  // $(".type-detail .add-to-cart-button").click(function () {
  //   var checkKosik = setInterval(function () {
  //     if ($(".msg-success").length) {
  //       // window.location.href = "/kosik";
  //       // clearInterval(checkKosik);
  //     }
  //   }, 100);
  // });

  if ($(".type-detail .flag-custom1").length) {
    $(".detail-bannery").addClass("strom");
  }

  if ($(".type-detail .flag-custom2").length) {
    $(".detail-bannery").addClass("strom");
  }
}
